var map = {
	"./Book open.svg": 45737,
	"./Compass.svg": 21800,
	"./Fast_forward.svg": 58864,
	"./Frame 3612.png": 59093,
	"./Globe.svg": 19919,
	"./Image.svg": 60943,
	"./Info.svg": 34068,
	"./Navigation.svg": 16086,
	"./Search.svg": 14164,
	"./Shopping cart.svg": 36358,
	"./Smile.svg": 69036,
	"./Star.svg": 95912,
	"./Tag.svg": 90456,
	"./Thumbs up.svg": 75842,
	"./Tool.svg": 15310,
	"./User.svg": 15817,
	"./Users.svg": 83880,
	"./Video.svg": 2777,
	"./agent.png": 75163,
	"./aiia.png": 54318,
	"./aiia_bg_cashier.png": 57060,
	"./aiia_frame.png": 26772,
	"./aiia_vid.mp4": 21571,
	"./attraction_aiia.png": 5142,
	"./avatar-lineup.png": 39933,
	"./black-podium-beneath-canopy-bioluminescent-trees.jpg": 28619,
	"./brain-robot-small1-1.jpg": 99826,
	"./building_aiia.png": 30895,
	"./building_checklist.png": 66227,
	"./building_video.png": 51442,
	"./chef.png": 65050,
	"./close-up-portrait-traveling-woman.jpg": 80732,
	"./comparison.png": 62861,
	"./customer-hardware-store-does-select-hammer-tool-showcase.png": 94300,
	"./daniel.png": 13439,
	"./elderly-woman-shopping-customer-day.jpg": 27819,
	"./electronic_aiia.png": 64769,
	"./electronic_builder.png": 53132,
	"./electronic_nav.png": 45954,
	"./electronic_staff.png": 92547,
	"./exmachina.jpg": 36854,
	"./freepik__expand__8375.png": 32369,
	"./furniture_aiia.png": 33863,
	"./furniture_bundled.png": 21335,
	"./furniture_image_based.png": 39996,
	"./furniture_shop.png": 92607,
	"./furniture_store.png": 32776,
	"./glenda.png": 52343,
	"./gordon.png": 44925,
	"./guest-hotel-is-ringing-bell-reception.jpg": 43131,
	"./hotel_check_in.png": 59685,
	"./hotel_facility.png": 97256,
	"./hotel_info.png": 27195,
	"./img_classic.png": 85800,
	"./img_glass.png": 35708,
	"./img_hologram.png": 77791,
	"./img_kiosk.png": 82489,
	"./img_tablet.png": 99902,
	"./keiji.png": 18,
	"./kiosk_classic.png": 90656,
	"./kiosk_frame.png": 31815,
	"./kiosk_glass.png": 54564,
	"./kiosk_group.png": 31089,
	"./kiosk_hologram.png": 29847,
	"./kiosk_tablet.png": 34102,
	"./kisok_kiosk.png": 777,
	"./male-executive-analyzing-graphs-digital-tablet-desk-coworking-space.jpg": 37313,
	"./mutilanguage.png": 85967,
	"./nav.png": 74695,
	"./online_order.png": 37442,
	"./qrcode.png": 22752,
	"./recommendation.png": 69607,
	"./recovery.png": 56987,
	"./restaurant_store.png": 83669,
	"./robotic-figure-with-glowing-orange-accents-contemplating-minimalist-setting-highlights-futuristic-design-advanced-technology.jpg": 9588,
	"./room-with-couch-table-with-plant-it.jpg": 90541,
	"./sandy.png": 15419,
	"./store-with-many-items-shelves-including-microwave-toaster.jpg": 57637,
	"./store1.png": 72038,
	"./store3.jpg": 34192,
	"./store5.jpg": 67334,
	"./store_solution.jpg": 73517,
	"./story2.png": 55913,
	"./story3.png": 84736,
	"./story4.png": 59743,
	"./supermarket_question.png": 36950,
	"./supermarket_recipe.png": 14828,
	"./supermarket_shop.png": 43214,
	"./supermarket_translate.png": 6986,
	"./talking-to-aiia.png": 20129,
	"./trans_ticket.png": 39415,
	"./trans_trip.png": 86338,
	"./zoey.png": 32705
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37624;